import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import {LayoutService} from "../../service/layout.service";

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {

    model: any[] = [];

    constructor(public layoutService: LayoutService) { }

    ngOnInit() {
        this.model = [
            {
                // label: 'Mein Klaus versichert',
                label: null,
                items: [
                  { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/ds/home'] },
                  { label: 'Verträge', icon: 'pi pi-file-edit', routerLink: ['/ds/contracts'] },
                  { label: 'Services', icon: 'pi pi-folder', routerLink: ['/ci/services'] },
                  // { label: 'Empfehle uns weiter', icon: 'pi pi-gift', routerLink: ['/cs/refer'] },
                  { label: 'Dokumente', icon: 'pi pi-file', routerLink: ['/ds/documents']},
                  { label: 'Einstellungen', icon: 'pi pi-fw pi-cog',expanded: true,
                    items: [
                      { label: 'Profil', icon: 'pi pi-user', routerLink: ['/ds/us/profile'] },

                      { label: 'Benachrichtigungen', icon: 'pi pi-bell', routerLink: ['/ds/us/notifications']},
                      { label: 'Passwort ändern', icon: 'pi pi-lock', routerLink: ['/ds/us/change-password']},
                      { label: 'Erstinformation', icon: 'pi pi-info-circle', routerLink: ['/ds/us/terms']},
                      { label: 'AGB', icon: 'pi pi-file', routerLink: ['/ds/us/agb']},
                      { label: 'Datenschutz', icon: 'pi pi-id-card', routerLink: ['/ds/us/privacy-policy']},
                      // { label: 'Freunde empfehlen', icon: 'pi pi-share-alt', routerLink: ['/ds/us/refer-friend']},
                      { label: 'Account löschen', icon: 'pi pi-trash', routerLink: ['/ds/us/delete-account']},
                    ] },
                ]
            },

        ];
    }
}
